const React = require('react');
const isNode = (typeof process !== 'undefined');
const SelectComponent = require('./../../FormComponents/Select');
const Input = require('./../../FormComponents/Input');

const housingTypeOptions = [
    { value: 'leilighet', label: 'Leilighet' },
    { value: 'lokale', label: 'Lokale' },
];

const canEnterOptions = [
    { value: 'ja', label: 'Ja' },
    { value: 'nei', label: 'Nei' },
];

class FeilOgMangler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            housingType: {value: null, label: null},
            canEnter: {value: null, label: null},
            aptNumRequired: false
        };

        this.setHousingType = this.setHousingType.bind(this);
        this.setCanEnter = this.setCanEnter.bind(this);
    }
    getValues() {
        return {
            address: this.address.value,
            aptNumber: this.aptNumber.value,
            housingType: this.state.housingType.label,
            canEnter: this.state.canEnter.label,
            comment: this.comment.value,
        }
    }
    setCanEnter(option) {
        this.setState({canEnter: option});
    }
    setHousingType(option) {
        this.setState({housingType: option});
        if (option.value === 'leilighet') {
            this.setState({aptNumRequired: true});
        } else {
            this.setState({aptNumRequired: false});
        }
    }
    render() {
        const {hideHeaders, color} = this.props;
        const housingType = this.state.housingType && this.state.housingType.value;
        const canEnter = this.state.canEnter && this.state.canEnter.value;

        return (
            <div className={`forms__inputContainer forms__inputContainer--${color}`}>
                {!hideHeaders && <h2 className="forms__formHeader">Feil og mangler</h2>}
                <div className="forms__formElement">
                    <Input validations="minLength:1" required name="address" type="text" placeholder="Adresse" ref={(address) => this.address = address}/>
                </div>
                <div className="forms__formElement">
                    <SelectComponent validations="isExisty" value={housingType} onChange={this.setHousingType} name="housingType" options={housingTypeOptions} className="react-select-custom" placeholder="Boligtype"/>
                </div>
                <div className="forms__formElement">
                    <Input
                        required={this.state.aptNumRequired} name="aptNumber" type="text" placeholder="Leilighetsnummer" ref={(aptNumber) => this.aptNumber = aptNumber}/>
                </div>
                <div className="forms__formElement">
                    <SelectComponent validations="isExisty" value={canEnter} onChange={this.setCanEnter} name="canEnter" options={canEnterOptions} className="react-select-custom" placeholder="Kan vi låse oss inn i leiligheten om nødvendig?"/>
                </div>
                <div className="forms__formElement">
                    <label className="form-label">Feilmelding. Skriv gjerne så utfyllende som mulig</label>
                    <textarea placeholder="Feilmelding. Skriv gjerne så utfyllende som mulig" ref={(comment) => this.comment = comment}/>
                </div>
            </div>
        )
    }
}

module.exports = FeilOgMangler;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/forms/FeilOgMangler/index.jsx